import Swiper from 'swiper';
import type { Swiper as SwiperInstance } from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

type SwiperHTMLElement = HTMLElement & { swiper?: SwiperInstance };

export function setupRelatedProduct(): void {
  const relatedItems = document.querySelectorAll<HTMLElement>('[related-products]');

  relatedItems.forEach((carousel) => {
    // Skip if already initialized
    if ((carousel as SwiperHTMLElement).swiper) return;

    // Find navigation buttons - check inside carousel first, then in parent container
    let nextEl = carousel.querySelector('.swiper-button-next') as HTMLElement | null;
    let prevEl = carousel.querySelector('.swiper-button-prev') as HTMLElement | null;

    // If not found inside, look in parent container (for new structure)
    if (!nextEl || !prevEl) {
      const container = carousel.closest('.related-products__slider-container');
      if (container) {
        nextEl = container.querySelector('.swiper-button-next') as HTMLElement | null;
        prevEl = container.querySelector('.swiper-button-prev') as HTMLElement | null;
      }
    }

    // If still not found, look in parent .related-products element
    if (!nextEl || !prevEl) {
      const parent = carousel.closest('.related-products');
      if (parent) {
        nextEl = parent.querySelector('.swiper-button-next') as HTMLElement | null;
        prevEl = parent.querySelector('.swiper-button-prev') as HTMLElement | null;
      }
    }

    const swiper = new Swiper(carousel, {
      modules: [Navigation, A11y],
      slidesPerView: 1,
      speed: 500,
      a11y: true,
      loop: false,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    });

    // Force update after a frame to fix width calculation issues
    requestAnimationFrame(() => {
      swiper.update();
    });
  });

  // Handle external links to ensure new tab gets focus on mobile
  const externalLinks = document.querySelectorAll<HTMLAnchorElement>('[related-products] a[target="_blank"]');
  externalLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const url = link.getAttribute('href');
      if (url) {
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
          newWindow.focus();
        }
      }
    });
  });
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupRelatedProduct);
} else {
  setupRelatedProduct();
}

// Force update all swipers after window load to fix any layout issues
window.addEventListener('load', () => {
  const carousels = document.querySelectorAll<HTMLElement>('[related-products]');
  carousels.forEach((carousel) => {
    const swiper = (carousel as SwiperHTMLElement).swiper;
    if (swiper) {
      swiper.update();
    }
  });
});
